import { DateTimeFormatOptions } from '@intlify/core-base';

export function formatDateTime(
  date: string,
  locale: string,
  isUtc: boolean = false,
  short: boolean = false,
) {
  const options: DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };

  if (!short) {
    options.hour = 'numeric';
    options.minute = '2-digit';
    options.hour12 = true;
  }

  if (isUtc) {
    options.timeZone = 'UTC';
  }

  return new Date(date).toLocaleDateString(locale, options);
}

export function formatDateTimeShort(
  date: string,
  locale: string,
  isUtc: boolean = false,
  short: boolean = false,
) {
  const options: DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };

  if (!short) {
    options.hour = 'numeric';
    options.minute = '2-digit';
    options.hour12 = true;
  }

  if (isUtc) {
    options.timeZone = 'UTC';
  }

  return new Date(date).toLocaleDateString(locale, options);
}
